/**
 * Daily Matters — <dm-slider>: feeds a CSS progress bar for a horizontally scrolling track.
 * Wrap a scroll-snap track marked with [data-dm-track]; the element exposes the scroll position
 * as --dm-progress (0..1) and data-dm-overflow="true|false" so the bar can hide when nothing scrolls.
 * Swiping itself is plain CSS; without this script only the progress bar stays still.
 */
if (!customElements.get('dm-slider')) {
  class DmSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-dm-track]');
      if (!this.track) return;
      this.onScroll = () => this.update();
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
      }
      this.update();
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const overflow = max > 1;
      this.dataset.dmOverflow = overflow ? 'true' : 'false';
      const progress = overflow ? Math.min(Math.max(this.track.scrollLeft / max, 0), 1) : 0;
      this.style.setProperty('--dm-progress', progress.toFixed(4));
    }
  }

  customElements.define('dm-slider', DmSlider);
}
